import React from "react";
import company from "assets/images/icon/company.png";
import companystatus from "assets/images/icon/company-status.png";
import onboard from "assets/images/icon/onboard.png";
import implementation from "assets/images/icon/implementation.png";
import Table from "../../components/Table";
import Button from "../../components/Button";
import PlusIcon from "assets/images/icon/plus-white.png";
import Input from "../../components/Input";
import search from "assets/images/icon/search-normal.png";
import ToggleSwitch from "../../components/ToggleSwitch";
import Card from "../../components/Card";
import { useNavigate } from "react-router-dom";
import routes from "constants/routes";
import PersonIcon from "assets/images/icon/person-icon";
import PersonsIcon from "assets/images/icon/persons-icon";
import UserChecked from "assets/images/icon/user-checked";
import UserDisabled from "assets/images/icon/user-disabled";
import { stringMerger } from "utils";

const headers = [
  { headerName: "Code", key: "code" },
  { headerName: "Name", key: "name" },
  { headerName: "Email", key: "email" },
  { headerName: "Residence", key: "residence" },
  { headerName: "Active Status", key: "active_status" },
  { headerName: "Employment Status", key: "emp_status" },
  { headerName: "Onboard Status", key: "onboard_status" },
  { headerName: "", key: "action" },
];

const data = [];

const userDetail = [
  { title: "Active Employees", count: 0, icon: <PersonIcon /> },
  { title: "Onboarding Blocking", count: 0, icon: <PersonsIcon /> },
  { title: "Onboard Needs Attention", count: 0, icon: <UserChecked /> },
  { title: "Terminated Employees", count: 0, icon: <UserDisabled /> },
];

function Employees() {
  const navigate = useNavigate();
  function handleView(details) {
    navigate(`/employees/view?code=${details.code}`);
  }
  return (
    <div className="content" style={{ padding: "16px 24px 16px 16px" }}>
      <div className="start-new-payroll-section">
        {/* <div className='breadcrumb-section pb-3 border-bottom mb-3'>
                    <h2 className='main-title mb-1'>Payroll</h2>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><a href="home">Home</a></li>
                            <li className="breadcrumb-item"><a href="dashboard">Employees</a></li>
                        </ol>
                    </nav>
                </div> */}
        <div>
          <div className="row mt-4">
            {userDetail?.map((item) => {
              return (
                <Card
                  title={item?.title}
                  count={item?.count}
                  icon={item?.icon}
                  isImage={false}
                />
              );
            })}
          </div>
        </div>
        <div>
          <div className="d-flex justify-content-between mt-5 mb-3">
            <div className="d-flex align-items-center gap-3">
              <Button
                startIcon={<img src={PlusIcon} />}
                onClick={() =>
                  navigate(
                    stringMerger(
                      routes.EMPLOYEES.HOME,
                      routes.EMPLOYEES.ADD_EDIT_EMPLOYEE
                    )
                  )
                }
              >
                Add Employees
              </Button>
              <ToggleSwitch />
            </div>
            <Input
              placeholder="Search by Name, Email, or Id"
              startIcon={search}
              style={{ width: "380px" }}
            />
          </div>
          <Table headers={headers} data={data} handleView={handleView} />
        </div>
      </div>
    </div>
  );
}

export default Employees;
